define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 演示子项对象类型。
     *
     * @exports EnumPresentationStatus
     * 
     * @see Presentation#status
     */
    var EnumPresentationStatus = {
        /**
         * 播放。
         * @type {Number}
         * @constant
         */
        PLAY: 1,

        /**
         * 暂停。
         * @type {Number}
         * @constant
         */
        PAUSE: 2,

        /**
         * 停止。
         * @type {Number}
         * @constant
         */
        STOP: 3,

        /**
         * 重置。
         * @type {Number}
         * @constant
         */
        CLEAR: 4
    }
    freezeObject(EnumPresentationStatus)
    /**
    * 反向查找对齐方式的名称。
    * 
    * @param {Number} value 对齐方式的数值。
    * @returns {String} 对齐方式的名称。
    */
    function getName(value) {
        for (var key in EnumPresentationStatus) {
            if (EnumPresentationStatus.hasOwnProperty(key) && EnumPresentationStatus[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        PLAY: 1,
        PAUSE: 2,
        STOP: 3,
        CLEAR: 4,
        getName: getName
    }
})